export default {
    required: 'obligatoire',
    invite: {
        panelTitle: 'Inviter de nouveaux agents',
        intro: 'Invitez des agents dans votre agence en saisissant manuellement leurs informations ci-dessous ou en téléchargeant un fichier CSV contenant des informations sur chaque agent à inviter. Votre agence a actuellement <strong>{{pending}}</strong> invitations en attente (max: <strong>{{max}}</strong>).',
        maxExceeded: 'Votre agence a atteint le nombre maximum d\'invitations en attente. Veuillez attendre que vos agents de voyages acceptent les invitations qui ont été envoyées ou révoquent certaines invitations en attente.',
        columns: {
            title: 'Titre',
            firstName: 'Prénom',
            lastName: 'Nom de Famille',
            email: 'Courriel',
            role: 'Rôle',
            agent: 'Agent',
            masterAgent: 'Agent chef'
        },
        addAgent: 'Ajouter un autre agent',
        addAgentDescription: 'Cliquez pour ajouter un autre agent à la liste.',
        uploadCsv: 'Importer un fichier CSV',
        uploadCsvDescription: 'Cliquez pour télécharger un fichier CSV d\'agents.',
        deleteRow: 'Supprimer la ligne',
        clearAll: 'Tout supprimer',
        clearAllDescription: 'Cliquez pour supprimer tous les agents.',
        submit: 'Envoyer les invitations',
        submitting: 'En cours...',
        csvModal: {
            modalTitle: 'Importer un fichier CSV',
            label: 'Invitez rapidement plusieurs agents en téléchargeant un fichier <strong>Comma-Separated Values</strong> (CSV).',
            placeholder: 'Choisir un fichier...',
            explanation: '<p>Le fichier CSV doit contenir une ligne par agent, chacun comprenant les colonnes suivantes. L\'ordre des colonnes n\'est pas important, mais le prénom doit précéder le nom de famille.</p>\n<ul><li>Titre (facultatif, valeurs possibles: <code>M.</code>, <code>Mme.</code>, <code>Mlle.</code>, <code>Dr.</code>)</li><li>Prénom</li><li>Nom de Famille</li><li>Courriel</li><li>Rôle (facultatif, valeurs possibles: <code>agent</code>, <code>master</code>)</li></ul><p>Exemple d\'un fichier CSV bien formé:</p><pre class="p-2 bg-secondary-light rounded">Mr.,John,Doe,john.doe@agenciaglobal.com,agent\nMs.,Jane,Doe,jane.doe@agenciaglobal.com,master</pre>',
            tooManyAgents: 'Votre fichier CSV téléchargé contient plus d\'agents que vous avez d\'invitations disponibles. Vous serez en mesure d\'envoyer plus après que vos agents de voyages acceptent leurs invitations.',
        },
        validation: {
            noAgents: 'Vous devez ajouter au moins un agent.',
            invalid: 'Certaines invitations ne sont pas valides, veuillez corriger les erreurs ci-dessus avant de procéder.',
            duplicateEmail: 'Vous ne pouvez pas envoyer plusieurs invitations à la même adresse courriel.'
        }
    },
    flight: {
        baseFare: 'Tarif de base',
        taxes: 'Taxes',
        taxesFees: 'Taxes et frais',
        subtotal: 'Sous-total',
        quantity: 'Quantité',
        total: 'Total',
        grandTotal: 'Somme finale',
        passengerType: 'Type de passager',
        passengerTypes: {
            adt: 'Adulte',
            chd: 'Enfant',
            inl: 'Bébé (genoux)',
            ins: 'Bébé (siège)'
        },
        from: 'À partir de {{price}}'
    },
    quote: {
        deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce signet?',
        unsubscribeConfirm: 'Êtes-vous sûr de vouloir vous désabonner de cette alerte tarifaire?',
        notFound: 'le forfait que vous avez mis en signet n\'est plus disponible.'
    },
    insurance: {
        options: {
            none: 'Pas de couverture'
        }
    },
    breakdown: {
        panelTitle: 'Répartition des prix',
        pricingCurrency: 'Les prix sont affichés en',
        ctCommissionNotice: 'La commission sur cette réservation est calculée uniquement après la fin de la location, mais représente généralement entre 5% et 15% du prix de la location. Il peut s\'écouler environ 30 jours avant que Agencia Global se réconcilie avec le fournisseur, après quoi votre agence recevra le paiement de la commission.<br><br>Toute majoration supplémentaire ajoutée à la réservation est immédiatement collectée et sera payée sur le relevé suivant.',
        header: {
            commission: 'Commission',
            commissionTbd: 'à déterminer',
            agencyMarkup: 'Majoration de l\'agence',
            merchantFee: 'Frais de service',
            totalMarkup: 'Majoration totale',
            maxMarkupTooltip: 'Majoration maximale: {{markup}}',
            merchantFeeTooltip: 'Toute majoration sera facturée sur le compte marchand Agencia Global et entraînera des frais marchands de 3% (plus les taxes applicables).',
        },
        charges: {
            cardTitle: 'Frais sur la carte de crédit du client',
            merchants: {
                car: 'sur le compte marchand de {{supplier}}',
                car_poa: 'à payer sur place à {{supplier}}',
                agencia: 'sur le compte marchand de Agencia Global'
            },
            currencyConversionNotice: '(Estimé en {{currency}} en utilisant les taux de change actuels, peut être facturé en monnaie locale)',
            merchantFeeNotice: 'comprend un frais de service de {{merchantFee}}% de',
            total: 'Frais total'
        },
        payout: {
            cardTitle: 'Paiements à l\'agence',
            markup: 'Majoration',
            commission: 'Commission',
            total: 'Paiement total'
        },
        tax: 'tax'
    },
    checkout: {
        errors: {
            generic: 'Nous n\'avons pas pu réserver ce vol pour le moment, veuillez réessayer plus tard.',
            genericTitle: 'Échec de la réservation',
            expired: 'Votre session a expiré, veuillez commencer une nouvelle recherche'
        }
    },
    cars: {
        search: {
            loading: {
                panelTitle: 'Nous sommes à la recherche de véhicules disponibles',
            },
            header: {
                panelTitle: 'Résultats de recherche pour votre itinéraire',
                pickup: 'Prise en charge à <strong>{{location}}</strong>, à <strong>{{date}}</strong>',
                return: 'Restitution à <strong>{{location}}</strong>, à <strong>{{date}}</strong>',
                currency: 'Devise',
                driverAge: 'Âge du conducteur',
                driverCountry: 'Pays de résidence ',
                refineSearch: 'Modifier votre recherche',
                redoSearch: 'Refaire la recherche'
            },
            filter: {
                panelTitle: 'Filtrer vos résultats',
                apply: 'Appliquer les filtres',
                reset: 'Réinitialiser les filtres',
                label: {
                    price: 'Prix',
                    suppliers: 'Fournisseur',
                    categories: 'Catégories',
                    passengers: 'Passagers',
                    baggage: 'Bagages',
                    doors: 'Portes',
                    transmissionTypes: 'Types de transmission',
                    driveTypes: 'Types de conduite',
                    fuelTypes: 'Types de carburant',
                    airConditioning: 'Climatisation',
                    rateQualifiers: 'Type de paiement',
                    fuelPolicies: 'Politiques de carburant',
                    mileage: 'Kilométrage',
                    pickupLocation: 'Comptoir de prise en charge',
                    returnLocation: 'Comptoir de restitution'
                }
            },
            results: {
                panelTitle: 'Véhicules disponibles pour la location',
                of: 'de',
                orSimilar: 'ou équivalent',
                passengerTooltip: 'Nombre de passagers',
                baggageTooltip: 'Capacité de bagages',
                doorTooltip: 'Nombre de portes',
                pickupLocation: 'Lieu de prise en charge',
                returnLocation: 'Lieu de restitution',
                mileageAllowance: 'Kilométrage',
                fuelPolicy: 'Politique de carburant',
                fuelType: 'Type de carburant',
                transmissionType: 'Type de transmission',
                driveType: 'Type de conduite',
                airConditioning: 'Climatisation',
                yes: 'Oui',
                no: 'Non',
                perDay: 'par jour',
                terms: 'Conditions générales',
                quote: 'Signet',
                book: 'Réserver',
                cancel: 'Cacher'
            },
            quote: {
                modalTitle: 'Sauvegarder un signet',
                pickup: 'Prise en charge',
                return: 'Restitution',
                location: '{{location}} à {{date}}',
                supplier: 'Fournisseur',
                vehicle: 'Véhicule',
                customer: 'Nom du client',
                notes: 'Notes',
                submit: 'Sauvegarder'
            }
        },
        checkout: {
            driver: {
                panelTitle: 'Détails du conducteur principal',
                licenseNotice: 'Le conducteur principal doit présenter un permis de conduire valide et une carte de crédit à son nom au moment de prise en charge.',
                title: 'Titre',
                titles: {
                    'Mr.': 'M.',
                    'Mrs.': 'Mme.',
                    'Ms.': 'Mlle.',
                    'Dr.': 'Dr.'
                },
                firstName: 'Prénom',
                lastName: 'Nom de famille',
                age: 'Âge',
                flight: 'Numéro de vol',
                flightTooltip: 'Fournir un numéro de vol permettra à la compagnie de location de voiture de suivre le vol de votre client afin de mieux tenir compte des retards et des annulations des compagnies aériennes.',
                phone: 'Numéro de téléphone',
            },
            equipment: {
                panelTitle: 'Équipement supplémentaire',
                equipmentNotice: 'Tous les extras sont payés lors du prise en charge au comptoir des fournisseurs. La disponibilité n\'est pas toujours garantie et les prix peuvent être sujets à changement.',
                currencyNotice: 'Les prix ci-dessous sont estimés en {{currency}} en utilisant les taux de change en vigueur, mais seront généralement facturés dans la devise locale.<br>Les prix exprimés en devise locale sont souvent disponibles dans les conditions de location.',
                taxExcl: '(tax excl.)'
            },
            payment: {
                panelTitle: 'Informations de paiement',
                cc: {
                    heading: 'Informations sur la carte de crédit',
                    type: 'Type de carte',
                    firstName: 'Prénom',
                    lastName: 'Nom de famille',
                    number: 'Numéro de carte',
                    expiry: 'Date d\'expiration',
                    expiryMonth: 'Mois',
                    expiryYear: 'Année',
                    cvv: 'CVV',
                },
                billing: {
                    heading: 'Adresse de facturation',
                    useSame: 'Identique à l\'adresse du conducteur principal'
                }
            },
            errors: {
                heading: 'Il y a une ou plusieurs erreurs dans la soumission de votre formulaire.',
                subheading: 'Veuillez corriger les erreurs suivantes, puis renvoyez-les.',
                generic: 'Une erreur s\'est produite lors du traitement de votre demande.',
                modalTitle: 'Quelque chose s\'est mal passé',
                newSearch: 'Nouvelle recherche',
                back: 'Retour aux résultats',
                close: 'Fermer'
            },
            acceptTerms: 'J\'accepte les <a href="{{url}}" target="_blank">conditions générales</a>',
            submit: 'Réserver le véhicule',
            processing: {
                modalTitle: 'Réservation en traitement',
                body: 'S\'il vous plaît soyez patient pendant que nous réservons votre location de voiture avec le fournisseur. Cela peut prendre quelques minutes.',
                notice: 'Ne quittez pas cette page et ne fermez pas votre navigateur avant la fin de ce processus.'
            }
        }
    },
    addressForm: {
        address: 'Adresse',
        apt: 'No. d\'appartement',
        city: 'Ville',
        country: 'Pays',
        province: 'Province',
        state: 'State',
        postal: 'Code postal',
        zip: 'Code zip'
    },
    phoneForm: {
        country: 'Code de numérotation du pays',
        number: 'Numéro',
        ext: 'Ext.'
    },
    format: {
        dateLong: 'dddd, [le] D MMMM, YYYY',
        dateTimeLong: 'H[h]mm, D MMMM, YYYY'
    },
    survey: {
        commentText: 'Vos commentaires...',
        buttonText: 'Soumettez votre réponse'
    }
};